import React from "react";
import Header from "../components/header";
import Topbar from "../components/Topbar";
import Footer from "../screen/Footer";

import HeroSection from "../components3/HeroSection";
import AboutSection from "../components3/AboutSection";
import ServicesSection from "../components3/ServicesSection";
import CtaSection from "../components3/CtaSection";
import TestimonialsSection from "../components3/TestimonialsSection";
import WhyChooseUs from "../components3/WhyChooseUs";

const WashingMachine = () => {
  return (
    <>
<Topbar/>
      <Header />

      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <CtaSection />
      <TestimonialsSection />
      <WhyChooseUs />
            <Footer />
    </>
  );
};

export default WashingMachine;